import Thread from "./Thread";
import Editor from "./Editor";

export default {
  Thread,
  Editor
};
